<template>
  <div class="grid grid-cols-2 gap-2">
    <with-error-message v-if="firstItem" :show-error="isFirstItemError" class="col-span-1 self-end">
      <base-label :id="firstItem.id"
                  :label="firstItem.label"
                  :tooltip="firstItem.tooltip"
                  :is-admin="isFirstItemAdmin"
      />
      <base-input :id="firstItem.id"
                  :name="firstItem.id"
                  :value="action[firstItem.id]"
                  :variant="isDisabled ? 'editor-disabled' : 'editor'"
                  type="number"
                  class="w-full border-gray mt-1"
                  :class="{'border-focus-error': isFirstItemError}"
                  :max="firstItem.max"
                  :min="firstItem.min"
                  :step="firstItem.step"
                  :disabled="isDisabled"
      />
    </with-error-message>

    <slot/>

    <with-error-message v-if="showUnreleased && secondItem" :show-error="isSecondItemError" class="col-span-1 self-end">
      <base-label :id="secondItem.id"
                  :label="secondItem.label"
                  :tooltip="secondItem.tooltip"
                  :is-admin="isSecondItemAdmin"
      />
      <base-input :id="secondItem.id"
                  :name="secondItem.id"
                  :value="action[secondItem.id]"
                  :variant="isDisabled ? 'editor-disabled' : 'editor'"
                  type="number"
                  class="w-full border-gray mt-1"
                  :class="{'border-focus-error': isSecondItemError}"
                  :max="secondItem.max"
                  :min="secondItem.min"
                  :step="secondItem.step"
                  :disabled="isDisabled"
      />
    </with-error-message>
  </div>
</template>

<script>
import WithErrorMessage from '@/components/common/WithErrorMessage.vue'

export default {
  name: 'ChatGPTEditorFormRowSplit',

  components: { WithErrorMessage },

  props: {
    firstItem: {
      type: Object,
      default: null
    },
    isFirstItemError: {
      type: Boolean,
      default: false
    },
    isFirstItemAdmin: {
      type: Boolean,
      default: false
    },
    secondItem: {
      type: Object,
      default: null
    },
    isSecondItemError: {
      type: Boolean,
      default: false
    },
    isSecondItemAdmin: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    action: {
      type: Object
    }
  }
}
</script>
